<template>
  <div>
    <PrimeDialog
      :header="`Select ${meta?.data.Table.TableNameUser}`"
      v-model:visible="visible"
      :style="{ 'min-width': '80vw' }"
      :modal="true"
    >
      <div
        class="flex flex-col gap-4 min-h-full"
        v-if="meta && recordData?.records"
      >
        <FormFilter
          :meta="meta"
          @apply="applyFilter()"
          v-model:filters="filterFormFilters"
        />
        <RecordTableShell
          v-if="meta && recordData?.records"
          :records="recordData?.records"
          :show-actions="false"
          :total="recordData?.total"
          :meta="meta"
          :table="pascalCaseTableName"
          :schema="props.schema"
        >
          <template #beforecolumns>
            <PrimeColumn>
              <template #body="slotProps">
                <PrimeButton
                  label="Select"
                  icon="pi pi-check"
                  @click="
                    () => {
                      visible = false;
                      emits('select', slotProps.data);
                    }
                  "
                />
              </template>
            </PrimeColumn>
          </template>
        </RecordTableShell>
      </div>
      <div v-else-if="loading"><UiLoader /></div>
      <div v-else>
        Meta data misconfiguration issue. Please check the table name and schema
        name provided.
      </div>
    </PrimeDialog>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  table: string;
  schema: string;
  filter?: { [key: string]: any };
}>();

const visible = defineModel<boolean>("visible");
const filterFormFilters = ref<{ [key: string]: any }>({});

const emits = defineEmits<{
  select: [value: any];
}>();

const pascalCaseTableName = props.table
  .split("_")
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join("");

const metaComposable = await useMetaAsync(pascalCaseTableName, props.schema);
const meta = metaComposable.data;

const {
  data: recordData,
  fetch,
  filters,
  loading,
} = useRecords(pascalCaseTableName, props.schema, metaComposable);

onMounted(() => {
  fetch();
});

async function applyFilter() {
  filters.value = { ...props.filter, ...filterFormFilters.value };
  await fetch();
}
</script>

<style scoped></style>
